export default action$ =>
  action$
    .ofType('PONG')
    .delay(1000)
    .mapTo({ type: 'PING' })



/** WEBPACK FOOTER **
 ** ./src/epics/pongEpic.js
 **/